<script lang="ts" setup>
// Properties
defineProps({
    clickTab: {
        type: Function,
        default: () => {
            return "";
        },
    },
});
// Data
</script>

<template>
    <div>
        <div class="mb-4 font-bold text-black">Your Online Testing Tool from ABC - CourseWave</div>
        <p class="mb-4">Data-Driven Instruction for your Classroom, covering 100% of state standards!</p>
        <p class="mb-8">
            Spend your time teaching–not creating and grading exams. Our experts have meticulously mapped out chapter,
            formative, and summative assessments with technology-enhanced questions directly to the state standards, in
            the same format your students will encounter on the state exams.
        </p>
        <div class="lg:flex">
            <div class="flex-none lg:w-3/5 lg:pr-16">
                <NuxtImg src="/images/products/book-details_coursewave-online-testing.png" alt="CourseWave Site" />
            </div>
            <div class="flex-1">
                <ul class="mt-8 ml-6 list-disc lg:mt-0 lg:ml-0">
                    <li class="pb-4">
                        Receive instant score feedback and utilize the built-in analytics to provide data-driven
                        instruction, mapped directly to state standards.
                    </li>
                    <li class="pb-4">
                        Easily recognize trends and patterns in student scores and identify knowledge gaps at the
                        student or classroom level.
                    </li>
                    <li class="pb-4">
                        From school or home, your students can access their assessments anywhere they access the
                        internet.
                    </li>
                    <li class="pb-4">
                        We make sign-in easy: your students can use their Clever, Google, or Microsoft accounts for
                        single sign on access.
                    </li>
                </ul>

                <div class="mt-6 text-center">
                    <ButtonSecondary @click="clickTab('tableOfContents')"> View Sample Questions </ButtonSecondary>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
